import React from "react";

const ManualBridge = () => {
  return (
    <div className="px-4 mt-4 space-y-6 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md sm:p-6 whitespace-normal">
      <p>
        Information is populated to the E-Citizen platform manually to generate
        the required documents for Electronic signing.
      </p>
      <p>
        Once all the incorporation forms have been generated, click "Confirm
        details" below to uploaded them in the next step.
      </p>
    </div>
  );
};

export default ManualBridge;
